import { render, staticRenderFns } from "./RemanentDetail.vue?vue&type=template&id=4656b107&scoped=true"
import script from "./RemanentDetail.vue?vue&type=script&lang=js"
export * from "./RemanentDetail.vue?vue&type=script&lang=js"
import style0 from "./RemanentDetail.vue?vue&type=style&index=0&id=4656b107&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4656b107",
  null
  
)

export default component.exports